import { render, staticRenderFns } from "./detay.vue?vue&type=template&id=2c6f5b3f&scoped=true&"
import script from "./detay.vue?vue&type=script&lang=js&"
export * from "./detay.vue?vue&type=script&lang=js&"
import style0 from "./detay.vue?vue&type=style&index=0&id=2c6f5b3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f5b3f",
  null
  
)

export default component.exports